import HyperHTMLElement from 'hyperhtml-element';
import spinnerCSS from '../../styles/less/components/spinner.less';

const spinnerStylesheet = new CSSStyleSheet();
spinnerStylesheet.replaceSync(spinnerCSS);

class Spinner extends HyperHTMLElement {
	declare shadow: ShadowRoot;
	declare active: boolean;

	static get booleanAttributes(): string[] {
		return ['active'];
	}

	created() {
		this.shadow = this.attachShadow({ mode: 'open' });
		this.shadow.adoptedStyleSheets = [spinnerStylesheet];
	}

	connectedCallback() {
		this.render();
	}

	attributeChangedCallback() {
		this.render();
	}

	show() {
		this.active = true;
	}

	hide() {
		this.active = false;
	}

	render() {
		this.html`
			<div class="aras-spinner">
				<div class="aras-spinner__content">
					<slot />
				</div>
				<div class="aras-spinner__container ${
					this.active ? 'aras-spinner__container_active' : ''
				}">
					<div class="aras-spinner__circle" />
				</div>
			</div>
		`;
	}
}

const name = 'aras-spinner';
if (!customElements.get(name)) {
	Spinner.define(name);
}

export default Spinner;
